import { Controller } from 'react-hook-form'
import { Input } from 'rsuite'
import classNames from 'classnames'

export default function EditTextCell({
  rowData,
  dataKey,
  register,
  control,
  errors,
  isEdit,
  required,
  disabled = false,
  onChangeCell = () => {},
  ...props
}) {
  let keyName = `${dataKey}_${rowData.id}`

  return (
    <div {...props}>
      {isEdit ? (
        <Controller
          name={keyName}
          control={control}
          defaultValue={rowData[dataKey]}
          value={rowData[dataKey]}
          rules={required ? required : { required: 'กรุณากรอกข้อมูล' }}
          render={(props) => {
            return (
              <Input
                className={classNames('rs-input', errors[keyName] && 'is-error-cell')}
                //defaultValue={props.defaultValue}
                disabled={disabled}
                value={props.value}
                placeholder={errors[keyName]?.message}
                onChange={(e) => {
                  props.onChange(e)
                  onChangeCell(e)
                }}
              />
            )
          }}
        />
      ) : (
        <span>{rowData[dataKey]}</span>
      )}
    </div>
  )
}
